import { defineComponent } from "vue"
import axios from "axios"
import { formatNumberWithLocale } from "~/utils/formatNumberWithLocale"
import { LOCALE } from "~/constants/locale"

interface ComponentData {
  trustpilotURL: string
  trustpilotRating: number
  trustpilotCustomers: number
  trustpilotCustomersFormatted: string
  $style: Record<string, any>
}

export default defineComponent({
  name: "TrustpilotBase",

  props: {
    lineBreaks: {
      type: Boolean,
      default: true
    },
    readReviewsLink: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: undefined
    },
    theme: {
      type: String,
      default: "dark",
      validator: (value: string) => ["dark", "light"].includes(value)
    }
  },

  data(): ComponentData {
    return {
      trustpilotURL: "",
      trustpilotRating: 0,
      trustpilotCustomers: 0,
      trustpilotCustomersFormatted: "0",
      $style: {}
    }
  },

  computed: {
    css(): string[] {
      const css: string[] = []

      if (this.width) {
        css.push(`width: ${this.width}px`)
      }

      return css
    },

    classes(): string[] {
      const classes: string[] = []
      classes.push(this.$style[this.theme])

      return classes
    }
  },

  async created() {
    const trustPilotConfig = this.$config.public.trustPilot
    let trustPilotId = trustPilotConfig.id
    let trustPilotURL = trustPilotConfig.url
    let trustPilotAPIKey = trustPilotConfig.apiKey
    if (this.$i18n.locale !== LOCALE.UK) {
      const upperCaseLocale = this.$i18n.locale.toUpperCase()
      trustPilotId = trustPilotConfig[`id${upperCaseLocale}`]
      trustPilotURL = trustPilotConfig[`url${upperCaseLocale}`]
      trustPilotAPIKey = trustPilotConfig[`apiKey${upperCaseLocale}`]
    }
    try {
      const axiosInstance = axios.create() as any
      const response = await axiosInstance.get(`https://api.trustpilot.com/v1/business-units/${trustPilotId}`, {
        params: {
          apikey: trustPilotAPIKey
        }
      })
      if (response.status === 200 && response.data) {
        this.trustpilotURL = trustPilotURL
        this.trustpilotRating = response.data.score.trustScore
        this.trustpilotCustomers = response.data.numberOfReviews.total
        this.trustpilotCustomersFormatted = formatNumberWithLocale(
          this.trustpilotCustomers,
          this.$i18n.locale
        )
      }
    } catch (err) {
      console.log("Trustpilot error", err)
    }
  }
})
